import React, { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ArrayInput, BooleanInput, FormDataConsumer, SelectInput, SimpleFormIterator, TimeInput, required } from 'react-admin';
import DateTimeInputUTC from '../../../components/DateTimeInputUTC';
import { daysOfTheWeek, frequencyChoices } from '../../../constants';


const inputWrapperSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: '0 0 20px 0',
};

const inputSx = {
  margin: '0 20px 0 0',
};

const daySx = {
  fontSize: 16,
  margin: '20px 0'
};

const FormSchedule = () => {

  return (
    <>
      <BooleanInput source="isSchedule" label="Ativar agendamento" defaultValue={false} />
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <Grid container spacing={2} sx={{ maxWidth: 800, mb: 2 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <DateTimeInputUTC
                  source="startAt"
                  label="Data inicial"
                  disabled={!formData.isSchedule}
                  validate={formData.isSchedule ? [required()] : []}
                  fullWidth
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <DateTimeInputUTC
                  source="endAt"
                  label="Data final"
                  disabled={!formData.isSchedule}
                  validate={formData.isSchedule ? [required()] : []}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ maxWidth: 800 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <SelectInput
                  label="Frequência"
                  source="frequency"
                  alwaysOn
                  choices={frequencyChoices}
                  disabled={!formData.isSchedule}
                  validate={formData.isSchedule ? [required()] : []}
                  fullWidth
                />
              </Grid>
            </Grid>
          </>
        )}
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData }) => {

          if (!formData.isSchedule) {
            return <></>;
          }

          if (formData.frequency === 'daily') {
            return (
              <Grid container spacing={2} sx={{ maxWidth: 800 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                  <TimeInput
                    source="startTime"
                    label="Horário inicial"
                    isRequired
                    validate={[required()]}
                    fullWidth
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <TimeInput
                    source="endTime"
                    label="Horário final"
                    isRequired
                    validate={[required()]}
                    fullWidth
                  />
                </Grid>
              </Grid>
            );
          };

          if (formData.frequency === 'weekly') {
            return (
              <ArrayInput source="weekSchedual" label="Defina os dias e horários">
                <SimpleFormIterator disableAdd disableRemove disableReordering>
                  <FormDataConsumer>
                    {({ scopedFormData }) => {
                      const day = daysOfTheWeek.find(wd => wd.id === scopedFormData?.dayOfTheWeek);
                      return (
                        <>
                          <Typography sx={daySx}>{day?.name}</Typography>
                          <Box sx={inputWrapperSx}>
                            <BooleanInput
                              source="isActive"
                              label={false}
                              sx={inputSx}
                            />
                            {scopedFormData && scopedFormData.isActive &&
                              <Fragment>
                                <TimeInput
                                  label='Horário inicial'
                                  source="startTime"
                                  style={{ marginRight: 20, width: 200 }}
                                  isRequired
                                />
                                <TimeInput
                                  label='Horário final'
                                  source="endTime"
                                  style={{ marginRight: 20, width: 200 }}
                                  isRequired
                                />
                              </Fragment>
                            }
                          </Box>
                        </>
                      );
                    }}
                  </FormDataConsumer>
                </SimpleFormIterator>
              </ArrayInput>
            );
          }
        }}
      </FormDataConsumer>
    </>
  );
};

export default React.memo(FormSchedule);